// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */
mat-card {
  font-size: 14px;
}

div#account-info {
  display: grid;
  grid-template-columns: auto 1fr auto 1fr;
}

div#owner-info, div#balance {
  grid-column: span 4;
  display: grid;
  grid: inherit;
  grid-template-columns: auto 1fr auto 1fr;
  grid-template-columns: subgrid;
}

.account-section-title {
  margin-top: 1.5em;
  grid-column: span 4;
}

div#id-info, div#owner-info-data, div#balance-values {
  grid-column: span 4;
  display: grid;
  grid: inherit;
  grid-template-columns: 6em 1fr 11em 1fr;
  grid-template-columns: subgrid;
  grid-gap: 1em;
  gap: 1em;
}

div#balance-money {
  display: flex;
  flex-direction: row;
}
div#balance-money div.balance-money-entry {
  margin-right: 1em;
}

div#account-actions {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1.5ex;
}

#transactions-card {
  margin-top: 32px;
}

#transactions-list-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 1em;
  gap: 1em;
}

.transaction-container {
  grid-column: span 4;
  grid: inherit;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-columns: subgrid;
  grid-gap: 1em;
  border-width: 1px 0 0 0;
  padding: 1em;
  border-color: lightgray;
  border-style: solid;
}
.transaction-container .transaction-data .data-title, .transaction-container .transaction-data table th {
  color: gray;
  font-size: 0.9em;
  font-weight: normal;
}
.transaction-container .transaction-data table th, .transaction-container .transaction-data table td {
  padding: 4px 8px;
}
.transaction-container .transaction-section {
  grid-column: span 4;
  grid: inherit;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-columns: subgrid;
  grid-gap: 1em;
}

#transactions-list-end {
  grid-column: span 4;
  border-width: 0 0 1px 0;
  border-color: lightgray;
  border-style: solid;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/points/components/account-detail/account-detail.component.scss"],"names":[],"mappings":"AACA,2HAAA;AACA;EACE,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,wCAAA;AAAF;;AAGA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,wCAAA;EACA,8BAAA;AAAF;;AAGA;EACE,iBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,uCAAA;EACA,8BAAA;EACA,aAAA;EACA,QAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;AAEE;EACE,iBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,sCAAA;EACA,aAAA;EACA,QAAA;AADF;;AAIA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sCAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AADF;AAII;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AAFN;AAMM;EACE,gBAAA;AAJR;AASE;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sCAAA;EACA,8BAAA;EACA,aAAA;AAPJ;;AAWA;EACE,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;AARF","sourcesContent":["\n/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */\nmat-card {\n  font-size: 14px;\n}\n\ndiv#account-info {\n  display: grid;\n  grid-template-columns: auto 1fr auto 1fr;\n}\n\ndiv#owner-info, div#balance {\n  grid-column: span 4;\n  display: grid;\n  grid: inherit;\n  grid-template-columns: auto 1fr auto 1fr;\n  grid-template-columns: subgrid;\n}\n\n.account-section-title {\n  margin-top: 1.5em;\n  grid-column: span 4;\n}\n\ndiv#id-info, div#owner-info-data, div#balance-values {\n  grid-column: span 4;\n  display: grid;\n  grid: inherit;\n  grid-template-columns: 6em 1fr 11em 1fr;\n  grid-template-columns: subgrid;\n  grid-gap: 1em;\n  gap: 1em;\n}\n\ndiv#balance-money {\n  display: flex;\n  flex-direction: row;\n\n  div.balance-money-entry {\n    margin-right: 1em;\n  }\n}\n\ndiv#account-actions {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 1.5ex;\n}\n\n#transactions-card {\n  margin-top: 32px;\n}\n\n#transactions-list-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-gap: 1em;\n  gap: 1em;\n}\n\n.transaction-container {\n  grid-column: span 4;\n  grid: inherit;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-template-columns: subgrid;\n  grid-gap: 1em;\n  border-width: 1px 0 0 0;\n  padding: 1em;\n  border-color: lightgray;\n  border-style: solid;\n\n  .transaction-data {\n    .data-title, table th {\n      color: gray;\n      font-size: 0.9em;\n      font-weight: normal;\n    }\n\n    table {\n      th, td {\n        padding: 4px 8px;\n      }\n    }\n  }\n\n  .transaction-section {\n    grid-column: span 4;\n    grid: inherit;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-template-columns: subgrid;\n    grid-gap: 1em;\n  }\n}\n\n#transactions-list-end {\n  grid-column: span 4;\n  border-width: 0 0 1px 0;\n  border-color: lightgray;\n  border-style: solid;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
